var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-title-wrapper",staticStyle:{"height":"40px important"}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-breadcrumbs',{staticClass:"px-2 py-0",attrs:{"items":_vm.items},scopedSlots:_vm._u([{key:"divider",fn:function(){return [_c('i',{staticClass:"pe-7s-angle-right-circle"})]},proxy:true}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }